var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-confirm',{attrs:{"confirm-title":"account.you_only_have_one_address","description":"account.desciption_you_only_have_one_address","oneOption":true},on:{"confirm":function($event){return _vm.$emit('closeModal')},"cancel":function($event){return _vm.$emit('closeModal')}}},[_c('icon-warning',{attrs:{"size":60}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }